const fetchTools = async (
  { commit, rootGetters, dispatch },
) => {
  commit('SET_FETCH_TOOLS_LOADING', true);
  try {
    const customer = rootGetters["customer/CUSTOMER"];
    const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
    let url = '/proxy/prompts-tools';
    let customer_id = customer.customer_id;

    if (customer.customer_id === 0) {
      customer_id = selected_customer.customer_id;
    }
    url += `?customer_id=${customer_id}`;

    const response = await window.axios.get(url);
    
    if (response && response.data.success) {
      commit('SET_TOOLS', response.data.tools);
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch('notifications/setError', error.message, { root: true });
  } finally {
    commit('SET_FETCH_TOOLS_LOADING', false);
  }
};

export default fetchTools;
